import { Stack, TextField, Typography } from '@mui/material';

import { WhatsAppFooterComponent } from 'domains/content/types';

const FOOTER_MAX_CHARS = 60;

export type Props = {
    footer: WhatsAppFooterComponent | null;
    onChange: (footer: WhatsAppFooterComponent | null) => void;
};

const WhatsAppTemplateFooter = ({ footer, onChange }: Props) => {
    const text = footer?.text ?? '';

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.slice(0, FOOTER_MAX_CHARS);
        onChange(value ? { type: 'FOOTER', text: value } : null);
    };

    return (
        <Stack spacing={1} data-testid="whatsapp-template-footer">
            <Typography variant="subtitle2" fontWeight={600}>
                Footer{' '}
                <Typography component="span" variant="caption" color="text.secondary">
                    (optional)
                </Typography>
            </Typography>
            <TextField
                data-testid="footer-text-input"
                label="Footer text"
                value={text}
                onChange={handleChange}
                inputProps={{ maxLength: FOOTER_MAX_CHARS, 'aria-label': 'Footer text' }}
                helperText={`${text.length} / ${FOOTER_MAX_CHARS} · No merge tags allowed`}
                size="small"
                fullWidth
                placeholder="e.g. Reply STOP to unsubscribe"
            />
        </Stack>
    );
};

export default WhatsAppTemplateFooter;
